import { UserTicketDanceEventStatisticsInterface } from '../../..';
import { TicketDanceEventStatisticsDto } from './ticket-dance-event-statistics.dto';
import { UserTicketCollapsedByUserDto } from './user-ticket-collapsed-by-user.dto';

export class UserTicketDanceEventStatisticsResponseDto implements UserTicketDanceEventStatisticsInterface {
  totalStatistics: TicketDanceEventStatisticsDto;
  ticketStatistics: TicketDanceEventStatisticsDto[];
  userTicketsCollapsedByUser: UserTicketCollapsedByUserDto[];
}
